<template>
    <div class="page">
        <table style="margin-top: 30px;" v-for="key, index in kcops_data" :key="index">
            <tr>
                <td>Критерий/аспекты</td>
                <th v-for="kcop in key.kcops" :key="kcop.id">{{ kcop.name }}</th>
            </tr>
            <tr v-for="criteria in criterias" :key="criteria.aspect_id">
                <td>
                    <b>{{ criteria.name_criteria }}</b> <br><br> {{ criteria.name_aspect }}
                </td>
                <td v-for="kcop in key.kcops" :key="kcop.id">{{ get_mark(criteria.criteria_id, criteria.aspect_id, kcop.id) }}</td> 
            </tr>
            <tr>
                <th><b>Сумма баллов</b></th>
                <th v-for="kcop in key.kcops" :key="kcop.id"><b>{{ kcop.summary }}</b></th>
            </tr>
            <!--<tr>
                <td width="20%" class="sign">{{ expert_data.position }}</td>
                <td width="20%" class="sign"></td>
                <td width="20%" class="sign"></td>
                <td width="20%" class="sign"></td>
                <td width="20%" class="sign"> 
                    <div style="width: 100% !important;">_____________ </div>{{ expert_data.surname }} {{ expert_data.name }}
                </td>
            </tr>-->
        </table>
        <br><br><hr>
        <table style="margin-top: 30px; width: 100%;" >
            <tr>
                <td class="sign">{{ expert_data.position }}</td>
                <td class="sign"></td>
                <td class="sign"></td>
                <td class="sign">________________________</td>
                <td class="sign"> 
                    {{ expert_data.surname }} {{ expert_data.name }}
                </td>
            </tr>
            <tr>
                <td class="sign"></td>
                <td class="sign"></td>
                <td class="sign"></td>
                <td class="sign">________________________</td>
                <td class="sign"> 
                    / Дата
                </td>
            </tr>
        </table>

    </div>
</template>


<script>

export default {
    name: 'Summary',
    data() {
        return {
            kcops_data: {},
            criterias: {},
            marks: {},
            expert_data: {}
        }
    },
    methods: {
        get_kcops() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/summary')
                .then(response => {
                    this.kcops_data = response.data.data
                    this.criterias = response.data.criterias
                    this.marks = response.data.marks
                    this.expert_data = response.data.expert_data
                    loader.hide();
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    //this.error_text = error.response.status + ' ' + error.response.data.data;
                    //this.isError = true;
                    console.log(error.response.status + ' ' + error.response.data.data)
            });
        },
        get_mark(criteria_id, aspect_id, kcop_id) {
            //console.log(criteria_id + ' - ' + aspect_id + ' - ' + kcop_id)
            let marks = this.marks
            let tmp = 0
            marks.forEach(element => {
                //console.log(element.kcop_criteria_id + ' - ' + element.kcop_aspect_id + ' - ' +  element.kcop_id)
                if((element.kcop_criteria_id == criteria_id)&&(element.kcop_aspect_id == aspect_id)&&(element.kcop_id == kcop_id)) {
                    console.log('match')
                    tmp = element.value
                }
            })
            return tmp
        }
    },
    created() {
        this.get_kcops()
    }
}

</script>


<style scoped>

.page {
    width: 21cm;
    min-height: 29.7cm;
    padding: 5px;
    margin: 1cm auto;
    border: 0px #D3D3D3 solid;
    border-radius: 5px;
    background: white;
}
table {
    border: 0px solid;
    border-spacing: 0px;
    font-size: 13px;
}
td {
    border: 1px solid #cccccc;   
}
th {
    text-align: left;
    padding: 4px;
    border: 1px solid #cccccc;  
}
.sign {
    padding-top: 40px;
    border: 0px;
}

</style>